export const UPDATE_ROW = 'UPDATE_ROW';
export const UPDATE_FAVORITE_ROW = 'UPDATE_FAVORITE_ROW';
export const REFRESH_TABLE = 'REFRESH_TABLE';
export const REFRESH_WIDGET_TABLE = 'REFRESH_WIDGET_TABLE';
export const ENTITY_MODAL_UPDATE = 'ENTITY_MODAL_UPDATE';
export const REMOVE_ROW = 'REMOVE_ROW';
export const REFRESH_CELLS = 'REFRESH_CELLS';
export const UPDATE_FILES_TO_SAVE = 'UPDATE_FILES_TO_SAVE';
export const UPDATE_PRODUCTS_MODAL_QUANTITY = 'UPDATE_PRODUCTS_MODAL_QUANTITY';
export const LEADS_MODAL_ACCOUNT_CREATED = 'LEADS_MODAL_ACCOUNT_CREATED';
